import styled from 'styled-components';
import AxisSelectIcon from '../../../../../assets/icons/axis-select.svg';

import { up } from 'styled-breakpoints';

export default function AxisSelectTag() {
  return <AxisSelect />;
}

const AxisSelect = styled(AxisSelectIcon)`
  height: 20px;
  /* width: auto; */
  /* padding-right: 60px; */
  float: left;
  left: 0;
  ${up('md')} {
    height: 21px;
  }
`;
